import React from 'react';
import PropTypes from 'prop-types';
import { sendEvent } from '@mrkt/features/Platform/googleAnalytics';

function logFirstMeaningfulPaint() {
  if (!logFirstMeaningfulPaint.called && 'Performance' in window) {
    logFirstMeaningfulPaint.called = true;

    sendEvent({
      eventCategory: 'Performance Metrics',
      eventAction: 'first-meaningful-paint',
      eventValue: performance.now(),
      nonInteraction: true,
    });
  }
}

export class MeaningfulPaint extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  componentDidMount() {
    logFirstMeaningfulPaint();
  }

  render() {
    return this.props.children;
  }
}
